import { FunctionComponent } from 'react';
import { Redirect } from 'react-resource-router';

const NotFound: FunctionComponent = () => {
  return <Redirect to="/error/user_not_found" />;
};

export default NotFound;
